import type { User } from 'oidc-client-ts';

import { getIdentityCookie } from './cookies';

export function getAccessToken(): string | undefined {
    return window.User?.access_token;
}

export function getIdToken(): string | undefined {
    return window.User?.id_token;
}

export function getUser(): User | null {
    return window.User ?? null;
}

export function hasValidSession(): boolean {
    return !!getIdentityCookie();
}
